var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraktorservice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402.96 109.62",
    style: {
      enableBackground: "new 0 0 402.96 109.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#849938;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.88,53.04 1.8,53.04 0,62.64 8.58,62.64 2.7,93.54 13.62,93.54 19.5,62.64 28.08,62.64  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.06,69.78h-0.12c0.9-2.28,1.44-4.2,1.8-6.12c-5.04-0.18-10.32,0-15.3,0.54l-1.32,7.14 c1.68,0.12,3.66,0.36,5.04,0.6v0.18l-4.14,21.42h10.74l1.14-6.06c2.22-11.7,6.24-15.36,10.26-13.86l2.4-10.5 C48,62.16,44.94,64.74,42.06,69.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.64,84.6c0,6.54,2.58,9.72,7.5,9.72c4.14,0,7.68-2.22,10.5-6.42h0.12c-0.84,2.04-1.26,3.66-1.74,5.7 c1.26,0.06,2.52,0.06,3.78,0.06c4.86,0,6.6-0.12,6.6-0.12s1.62-10.32,5.34-29.52C78.6,63.24,74.28,63,70.38,63 C57.24,63,50.64,72.96,50.64,84.6z M70.26,73.14c-0.96,4.98-5.1,11.7-7.38,11.7c-0.9,0-1.14-0.78-1.14-2.34 c0-4.56,2.64-10.92,6.72-10.92c0.84,0,1.44,0.12,2.04,0.3L70.26,73.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.56,61.56L98.1,75.18l4.86-25.5c-5.7-0.18-11.04,0-16.02,0.54l-1.32,7.14c1.74,0.12,3.66,0.36,5.04,0.6 l-0.06,0.18l-6.72,35.4h10.74l2.64-13.8l3.9,13.8h12.9l-6.48-15.78l10.74-10.98L109.56,61.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.32,72.12h5.46l1.68-8.4h-5.52l1.98-10.5l-11.1,2.1l-1.62,8.4h-3.6l-1.68,8.4h3.72l-2.1,11.16 c-1.44,7.74,0.72,10.98,7.56,10.98c1.98,0,4.62-0.3,6.9-0.9l1.26-8.52c-0.96,0.18-1.92,0.36-3.18,0.36c-1.68,0-2.04-0.6-1.68-2.7 L133.32,72.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.94,63c-9.36,0-18.9,7.08-18.9,20.4c0,6.6,3.12,10.86,12.66,10.86c9.84,0,18.78-7.98,18.78-20.16 C171.48,67.74,168.36,63,158.94,63z M153.96,84.72c-2.1,0-2.7-1.38-2.7-2.94c0-3.66,1.86-9.3,6-9.3c2.22,0,2.94,1.02,2.94,3.06 C160.2,79.26,158.46,84.72,153.96,84.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.58,69.78h-0.12c0.9-2.28,1.44-4.2,1.8-6.12c-5.04-0.18-10.32,0-15.3,0.54l-1.32,7.14 c1.68,0.12,3.66,0.36,5.04,0.6v0.18l-4.14,21.42h10.74l1.14-6.06c2.22-11.7,6.24-15.36,10.26-13.86l2.4-10.5 C194.52,62.16,191.46,64.74,188.58,69.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.22,73.56c0,6.84,5.64,7.86,5.64,10.74c0,0.9-0.78,1.44-2.46,1.44c-1.38,0-3.54-0.42-4.62-0.84l-1.8,8.82 c1.5,0.3,3.54,0.54,5.52,0.54c10.44,0,14.76-5.82,14.76-10.86c0-6.3-5.88-8.76-5.88-10.92c0-1.02,0.78-1.5,2.7-1.5 c1.02,0,2.22,0.18,3.3,0.48l1.98-8.1c-1.5-0.24-3.24-0.36-4.92-0.36C204.78,63,200.22,67.62,200.22,73.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.66,63c-8.34,0-17.52,6.78-17.52,20.52c0,6.36,2.64,10.74,11.34,10.74c4.02,0,8.46-0.72,12.36-2.04V84 c-3,1.14-6.18,1.8-9.06,1.8c-3.24,0-4.02-0.72-4.02-2.34v-0.72c10.14-0.18,17.88-3.54,17.88-11.7C248.64,67.38,246.66,63,237.66,63 z M231.72,76.02c0.72-2.34,2.16-5.04,4.8-5.04c1.2,0,1.74,0.6,1.74,1.5C238.26,75.12,235.38,75.96,231.72,76.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.2,69.78h-0.12c0.9-2.28,1.44-4.2,1.8-6.12c-5.04-0.18-10.32,0-15.3,0.54l-1.32,7.14 c1.68,0.12,3.66,0.36,5.04,0.6v0.18l-4.14,21.42h10.74l1.14-6.06c2.22-11.7,6.24-15.36,10.26-13.86l2.4-10.5 C271.14,62.16,268.08,64.74,265.2,69.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.67,79.02h-0.12c-0.12-2.82-0.36-5.94-0.78-8.94l-0.9-6.36H276.6l4.92,29.82h11.28l15.06-28.32 l-10.62-2.88L289.67,79.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.89,48.84c-3.6,0-6.96,2.82-6.96,6.72c0,3.06,2.46,5.88,6.12,5.88c3.6,0,6.96-2.82,6.96-6.84 C328.01,51.66,325.49,48.84,321.89,48.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.23,64.2l-1.32,7.14c1.74,0.12,3.66,0.36,5.04,0.6v0.12l-4.14,21.48h10.74l5.7-29.88 C319.55,63.48,314.21,63.66,309.23,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.69,72.36c1.2,0,2.34,0.18,3.36,0.6l2.52-9.48c-1.8-0.36-3.54-0.54-5.4-0.54 c-10.98,0-18.12,8.88-18.12,20.4c0,7.02,3.66,11.04,11.88,11.04c2.04,0,4.2-0.24,6.18-0.84l1.14-9.48c-1.26,0.42-2.7,0.6-4.02,0.6 c-2.52,0-3.84-1.38-3.84-3.72C338.39,77.04,340.25,72.36,344.69,72.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.49,63c-8.34,0-17.52,6.78-17.52,20.52c0,6.36,2.64,10.74,11.34,10.74c4.02,0,8.46-0.72,12.36-2.04V84 c-3,1.14-6.18,1.8-9.06,1.8c-3.24,0-4.02-0.72-4.02-2.34v-0.72c10.14-0.18,17.88-3.54,17.88-11.7C378.47,67.38,376.49,63,367.49,63 z M361.55,76.02c0.72-2.34,2.16-5.04,4.8-5.04c1.2,0,1.74,0.6,1.74,1.5C368.09,75.12,365.21,75.96,361.55,76.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.9,22.79C399.24,15.4,401.8,4.45,402.96,0c-2.9,3.98-9.35,6.39-13.5,7.39c-3.78,0.92-11.1,1.93-18.09,5.3 c-6.95,3.35-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29C364.21,28.98,369.51,28.08,381.9,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374,30.52c-17.33,7.39-19.9,18.34-21.06,22.8c2.89-3.98,9.35-6.39,13.5-7.39c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C391.7,24.34,386.39,25.23,374,30.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraktorservice);
export default __webpack_public_path__ + "static/media/Traktorservice.5b8518ea3e88463024282f89cea284ef.svg";
export { ForwardRef as ReactComponent };